import React from 'react';

import type { FormInstance, FormItemProps } from 'antd'
import { Form } from 'antd';
import cn from 'classnames';

import { Input } from '@element/index';
import { I18n } from '@utils/index';

import { formatFloatVal, formatIntVal } from '../utils';

import styles from './index.module.less';

const { Item } = Form;

interface InputBaseFieldProps {
  className?: string;
  name: string;
  min: string | number | ((form: FormInstance) => React.ReactNode);
  max: string | number | ((form: FormInstance) => React.ReactNode);
  label?: string | ((form: FormInstance) => string);
  shouldUpdate: (prev: any, curr: any) => boolean;
  inputMode: 'numeric' | 'decimal';
  rules?: FormItemProps['rules'];
  minSign?: string;
  maxSign?: string;
}

export const InputBaseField: React.FC<InputBaseFieldProps> = (props) => {
  const { name, className, min, max, label, shouldUpdate, inputMode, rules, minSign = '≤', maxSign = '<' } = props;
  const onblur = value => {
    if (value === '.') {
      return '';
    }
    const arr = value.split('');
    if (arr[0] === '.') {
      arr.unshift(0);
    } else if (arr[arr.length - 1] === '.') {
      arr.push(0);
    }
    return arr.join('');
  }
  return (
    <Item className={className} shouldUpdate={shouldUpdate}>
      {(form) => {
        return (
          <div className={styles.container}>
            <span className={cn(styles.label, styles.general_color)}>{
              typeof label === 'string' ? label : label?.(form as FormInstance)
            }</span>
            <div className={styles.main}>
              <p className={styles.item}>
                <span className={cn(styles.general_color, 'DINPro')}>{
                  typeof min === 'function' ? min?.(form as FormInstance) : min
                }</span>
                <span className={styles.general_color}>{minSign}</span>
              </p>
              <Item
                name={name}
                className={cn(styles.item, styles.formItem)}
                rules={rules}
                validateTrigger={['onBlur', 'onChange']}
              >
                <Input
                  placeholder={I18n.t('pleaseInput')}
                  inputMode={inputMode}
                  className={cn(styles.input, 'DINPro')}
                  value={form.getFieldValue(name)}
                  theme="dark"
                  autocomplete="off"
                  onChange={(e) => {
                    const { value } = e.target;
                    const formatValue = inputMode === 'decimal' ? formatFloatVal(value) : formatIntVal(value);
                    form.setFieldValue(name, `${formatValue}`);
                  }}
                  onPaste={e => {
                    e.preventDefault();
                  }}
                  onBlur={ e => {
                    const { value } = e.target;
                    if (!value) {
                      return;
                    }
                    const val = inputMode === 'decimal' ? onblur(value) : formatIntVal(value);
                    form.setFieldValue(name, `${+val}`);
                  }}
                />
              </Item>
              <p className={styles.item}>
                <span className={styles.general_color}>{maxSign}</span>
                <span className={cn(styles.general_color, 'DINPro')}>{
                  typeof max === 'function' ? max?.(form as FormInstance) : max
                }</span>
              </p>
            </div>
          </div>
        );
      }}
    </Item>
  );
}
